<template>
  <div class="confirm-delete">
    <el-dialog
      :visible.sync="dialogOpen"
      :show-close="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="confirm-delete__title">Confirm deletion?</div>

      <div class="confirm-delete__buttons">
        <button class="save-btn" @click="del">Confirm</button>
        <button class="cancel-btn" @click="cancel">Cancel</button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "ConfirmDelete",
  computed: {
    dialogOpen: {
      get() {
        return this.$store.state.Dialog.confirmDeleteDialog;
      },
      set(value) {
        this.$store.commit("Dialog/setData", {
          label: "confirmDeleteDialog",
          data: value,
        });
      },
    },
  },
  methods: {
    cancel() {
      this.$store.commit("Dialog/setData", {
        label: "confirmDeleteDialog",
        data: false,
      });
      this.$store.commit("Dialog/setData", {
        label: "confirmDeleteDialogData",
        data: null,
      });
      this.filterName = "";
    },
    del() {
      const method = "DELETE";
      const removeId = this.dialogOpen.id;
      this.$axios({
        method,
        url: `${this.$config.baseURL}/admin/people/user_report/${this.dialogOpen.id}`,
      })
        .then((data) => {
          // this.$emit("updateUserReports");
          this.$store.commit("Main/removeData", {
            label: "userReports",
            data: removeId,
          });
        })
        .catch((error) => {
          this.loadingData = true;
          console.error(error);
        });

      this.$store.commit("Dialog/setData", {
        label: "confirmDeleteDialog",
        data: false,
      });
      this.$store.commit("Dialog/setData", {
        label: "confirmDeleteDialogData",
        data: null,
      });
    },
  },
};
</script>

<style lang="scss">
@import "../../assets/styles/helpers/mixin";
@import "../../assets/styles/helpers/variables";
.confirm-delete {
  .el-dialog__header {
    padding: 0;
  }

  .el-dialog {
    margin-top: 30rem !important;
    width: 49rem;

    @include below($md) {
      width: 90%;
      margin-top: 10rem !important;
    }
  }

  .el-select {
    width: 100%;

    .el-input .el-input__inner {
      border: 1px solid #c6d5e0;
      padding: 0 2rem;
    }
  }

  &__title {
    font-size: 2.4rem;
    font-weight: 700;
    color: #262a2e;
    border-bottom: 1px dashed $border;
    margin-bottom: 3rem;
  }

  &__subtitle {
    font-size: 1.6rem;
    font-weight: 700;
    color: #262a2e;
    margin-bottom: 0.6rem;

    &.error {
      color: $dark_red;
    }
  }

  &__name {
    margin-bottom: 2rem;

    &-field {
      border: 1px solid #c6d5e0;
      width: 100%;
      height: 4.5rem;
      padding: 0 2rem;
      font-size: 1.6rem;

      &.error {
        border-color: $dark_red;

        &::placeholder {
          color: $dark_red;
        }
      }
    }

    .input-error {
      color: $red;
      font-size: 1.4rem;
      font-weight: 600;
      margin-top: 1rem;
    }
  }

  &__selected {
    margin-bottom: 2rem;

    &-group {
      margin-bottom: 1rem;
    }

    .group-title {
      font-size: 1.2rem;
      font-weight: 700;
      text-transform: uppercase;
      color: #262a2e;
      border-bottom: 1px dashed $border;
      padding-bottom: 0.2rem;
      margin-bottom: 1rem;
    }
  }

  .save-btn {
    background: $red;
    border: none;
    font-size: 1.6rem;
    color: #fff;
    font-weight: 600;
    padding: 1rem 4rem;
    margin-right: 3rem;
  }

  .cancel-btn {
    background: none;
    border: none;
    font-size: 1.6rem;
    color: #383838;
  }
}
</style>
